{
  "menu": {
    "dashboard": "Главная",
    "faq": "Виртуальная АТС"
  },
  "getting_started": "С чего начать?",
  "users": "Раздел «Пользователи»",
  "users_features": "Сервисы пользователя",
  "personal_acc": "ЛК Пользователя",
  "add_devices": "Добавление устройств",
  "groups": "Раздел «Группы»",
  "groups_examples": "Примеры настройки",
  "phone_numbers": "Раздел «Телефонные номера»",
  "incoming_route_work_hours": "Рабочие часы",
  "incoming_route_nums": "Номера телефонов",
  "incoming_route_alg": "Управление входящими вызовами",
  "integrations": "Интеграции",
  "B24": "Битрикс24",
  "auto_attendant": "Виртуальный секретарь",
  "call_records": "Раздел «Записи разговоров»",
  "devices": "Раздел «Устройства»",
  "voice_mail": "Раздел «Голосовая почта»",
  "fax": "Раздел «Факс»",
  "service_codes": "Раздел «Сервисные коды»",
  "control_by_device": "Управление вызовом с телефонного аппарата",
  "device_features": "Управленеие телефоном",
  "call_transfer": "Переадресация вызова",
  "parking": "Парковка вызова",
  "call_pickup": "Перехват вызова",
  "faq": "Виртуальная АТС",
  "hardware_instructions": "Настройка оборудования",
  "need_help": "Нужна помощь?",
  "statistics": "Раздел «Статистика»",
  "vuestic.breadcrumbs": "Путь",
  "vuestic.cancel": "Отмена",
  "vuestic.dropzone": "Перетащите файлы",
  "vuestic.uploadFile": "Загрузить изображение"
}
